import { ReactNode } from "react";
import { UserMenu, BackNavigationButton, Logo } from "components";
import { useMatchesBreakpoint } from "hooks/useMatchesBreakpoint";
import { useNavigate } from "react-router-dom";

export interface HeadingProps {
  children: ReactNode;
}

export const DetailsHeading = ({ children }: HeadingProps) => {
  const showLogoAndUserMenu = useMatchesBreakpoint("md");
  const navigate = useNavigate();

  return (
    <div className="z-20 py-4 px-2 text-white bg-center bg-no-repeat bg-cover sm:shadow-md bg-[url('/public/ylapalkki_tausta.png')]">
      <div className="container flex gap-2 justify-between items-center mx-auto">
        {showLogoAndUserMenu && <Logo />}
        <div className="flex flex-shrink justify-start items-center w-3/4 sm:w-5/6 text-2xl font-bold">
          <BackNavigationButton onClick={() => navigate(-1)} />
          <div className="overflow-hidden whitespace-nowrap text-ellipsis">
            {children}
          </div>
        </div>
        <div className="flex gap-x-2 justify-end items-center">
          {showLogoAndUserMenu && (
            <div className="inline-flex text-kvarn-dark-green">
              <UserMenu />
            </div>
          )}
          {/* <SelectedContactAvatar /> */}
        </div>
      </div>
    </div>
  );
};
